// Module
var code = "<div class=\"row section-header\"> <div class=\"col text-truncate\"> <h4>{{ room.projectRoom.name }} blueprint</h4> </div> <div class=\"col-auto\"> <a ui-sref=\"projects-detail.blueprints.list-blueprints\" class=\"btn btn-link\"><i class=\"fa fa-angle-double-left\"></i> back</a> </div> </div> <blueprint room=\"room\"></blueprint> ";
// Exports
module.exports = code;